






import { defineComponent } from '@vue/composition-api';
import WeeklyChallengeBaseForm from './WeeklyChallangeBaseForm.vue';
import { useWeeklyChallenge } from '@/bundles/ActivityGroup/composables/useWeeklyChallenge';

export default defineComponent({
  name: 'WeeklyChallengeCreateForm',
  components: {
    WeeklyChallengeBaseForm,
  },

  emits: ['list:refresh', 'close'],

  setup(_, {emit}) {
    const { createWeeklyChallenge, loading } = useWeeklyChallenge();

    async function submitEventHandler(payload: any) {
      await createWeeklyChallenge(payload);
      emit('list:refresh');
    }

    return {
      submitEventHandler,
      loading,
    };
  },
});
